module.exports = __webpack_public_path__ + "img/frequency.4ea479b4.svg";